module.exports = __webpack_public_path__ + "img/lucas-mccallum-logo-white.e98257c0.svg";